if (!customElements.get('marketplace-links')) {
  class MarketplaceLinks extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[type="application/json"]');
      if (!dataEl) return;

      this.linksByVariant = JSON.parse(dataEl.textContent);
      this.buttons = this.querySelectorAll('[data-marketplace]');
      this.section = this.closest('.js-product');
      this.designMode = this.dataset.designMode === 'true';

      const variantPicker = this.section && this.section.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }
    }

    handleVariantChange(event) {
      const variant = event.detail && event.detail.variant;
      this.updateLinks(variant ? variant.id : null);
    }

    updateLinks(variantId) {
      const links = (variantId && this.linksByVariant[variantId]) || {};
      let visibleCount = 0;

      this.buttons.forEach((button) => {
        const key = button.dataset.marketplace;
        const url = links[key];

        if (url) {
          button.href = url;
          button.hidden = false;
          visibleCount += 1;
        } else {
          button.removeAttribute('href');
          button.hidden = true;
        }
      });

      this.hidden = visibleCount === 0 && !this.designMode;
    }
  }

  customElements.define('marketplace-links', MarketplaceLinks);
}
